import MentorReport from './components/MentorReport';
import MentorManagement from './components/MentorManagement';
import StudentAnniversaries from './components/StudentAnniversaries';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import OrderManagement from './components/OrderManagement';
import PaymentList from './components/PaymentList';
import AddStudentForm from './components/AddStudentForm';
import StudentList from './components/StudentList';
import AddEventForm from './components/AddEventForm';
import EventList from './components/EventList';
import AddCourseForm from './components/AddCourseForm';
import CourseList from './components/CourseList';
import AddPaymentForm from './components/AddPaymentForm';
import MonthlyFeeReport from './components/MonthlyReport';
import MonthlyReportLate from './components/MonthlyLateFeeReport';
import YearlyReport from './components/YearlyReport';
import EditEventForm from './components/EditEventForm';
import EventEnrollmentReport from './components/EventEnrollmentReport';
import ManagementDashboard from './components/ManagementDashboard';
import StudentPayment from './components/StudentPaymentReport';
import PaymentEdit from './components/PaymentEdit';
import Approve from './components/StudentApproval';
import AddPayBeta from './components/AddPayBeta';
import RunningPaymentForm from './components/RunningPaymentForm';
import RunningPayManage from './components/RunningPayManage';
import ProductMaster from './components/ProductMaster';
import GroupedProductMapping from './components/GroupedProductMapping';
import RunningSaleReport from './components/RunningSaleReport';
import NewAdmission from './components/NewAdmission';
import SmartReporting from './components/SmartReporting';
import BulkDelivery from './components/BulkDelivery';






function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/reports/order-management" element={<OrderManagement />} />
        <Route path="/reports/mentors" element={<MentorReport />} />
        <Route path="/mentors" element={<MentorManagement />} />
        <Route path="/students/add" element={<AddStudentForm />} />
        <Route path="/students/list" element={<StudentList />} />
        <Route path="/reports/student-anniversaries" element={<StudentAnniversaries />} />
        <Route path="/events/add" element={<AddEventForm />} />
        <Route path="/events/list" element={<EventList />} />
        <Route path="/courses/add" element={<AddCourseForm />} />
        <Route path="/courses/list" element={<CourseList />} />
        <Route path="/payments/add" element={<AddPaymentForm />} />
        <Route path="/reports/monthly" element={<MonthlyFeeReport />} />
        <Route path="/reports/payments" element={<PaymentList />} />
        <Route path="/reports/monthlyLate" element={<MonthlyReportLate />} />
        <Route path="/reports/Yearly" element={<YearlyReport />} />
        <Route path="/events/edit/:id" element={<EditEventForm />} />
        <Route path="/reports/event-enrollment" element={<EventEnrollmentReport />} />
        <Route path="/reports/management" element={<ManagementDashboard />} />
        <Route path="/reports/studentPayment" element={<StudentPayment />} />
        <Route path="/payments/manage" element={<PaymentEdit />} />
        <Route path="/students/Approve" element={<Approve />} />
        <Route path="/Dev/PayBeta" element={<AddPayBeta />} />
        <Route path="/payments/running" element={<RunningPaymentForm />} />
        <Route path="/products" element={<ProductMaster />} />
        <Route path="/products/mapping" element={<GroupedProductMapping />} />
        <Route path="/payments/running/manage" element={<RunningPayManage />} />
        <Route path="/reports/running-sales" element={<RunningSaleReport />} />
        <Route path="/reports/smart" element={<SmartReporting />} />
        <Route path="/deliveries/bulk" element={<BulkDelivery />} />
        <Route path="/reports/new-admissions" element={<NewAdmission />} />
      </Routes>
    </Router>
  );
}

export default App;